import { Divider, styled } from "@mui/material";

const WhiteDivider = styled(Divider)(({theme}) => ({
    borderColor: theme.palette.common.white
}));

export default WhiteDivider;